/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_No_EvidenceInputs */

const en_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const de_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const fr_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const es_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const it_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const nl_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const pl_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const fi_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const da_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

const sv_deep_match_no_evidence = /** @type {(inputs: Deep_Match_No_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No evidence found`)
};

/**
* | output |
* | --- |
* | "No evidence found" |
*
* @param {Deep_Match_No_EvidenceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_no_evidence = /** @type {((inputs?: Deep_Match_No_EvidenceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_No_EvidenceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_no_evidence(inputs)
	if (locale === "fr") return fr_deep_match_no_evidence(inputs)
	if (locale === "es") return es_deep_match_no_evidence(inputs)
	if (locale === "it") return it_deep_match_no_evidence(inputs)
	if (locale === "nl") return nl_deep_match_no_evidence(inputs)
	if (locale === "pl") return pl_deep_match_no_evidence(inputs)
	if (locale === "fi") return fi_deep_match_no_evidence(inputs)
	if (locale === "da") return da_deep_match_no_evidence(inputs)
	if (locale === "sv") return sv_deep_match_no_evidence(inputs)
	return en_deep_match_no_evidence(inputs)
});